import { render, staticRenderFns } from "./ProdutosCadastrados.vue?vue&type=template&id=3fc91a03&"
import script from "./ProdutosCadastrados.vue?vue&type=script&lang=js&"
export * from "./ProdutosCadastrados.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosCadastrados.vue?vue&type=style&index=0&id=3fc91a03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports